import { Box, Stack, Typography, useTheme } from '@mui/material';
import { t } from 'i18next';
import BillingDetail from 'src/features/Setting/PlanUsage/BillingDetail';
import Usage from 'src/features/Setting/PlanUsage/Usage';

const PlanUsage = () => {
  const theme = useTheme();

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h6">{t('Plan & Usage')}</Typography>
        <Typography variant="body2" color={'text.secondary'}>
          {t('setting.plan_usage.sub_title')}
        </Typography>
      </Box>
      <Stack direction="row" spacing={2}>
        <Stack
          p={2}
          height="fit-content"
          border={`1px solid ${theme.palette.divider}`}
          borderRadius={theme.shape.borderRadius / 2}
          flex={1}
        >
          <Usage />
        </Stack>
        <Stack
          p={2}
          height="fit-content"
          border={`1px solid ${theme.palette.divider}`}
          borderRadius={theme.shape.borderRadius / 2}
          flex={1}
          direction="column"
          spacing={2}
        >
          <BillingDetail />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PlanUsage;
